"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm1-2H9v-2h2v2zm0-3H9V4h2v9z"];
//# sourceMappingURL=issue.js.map